/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_05_AltInputs */

const en_elastic_gallery_item_05_alt = /** @type {(inputs: Elastic_Gallery_Item_05_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Futuristic technology detail`)
};

const ar_elastic_gallery_item_05_alt = /** @type {(inputs: Elastic_Gallery_Item_05_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفاصيل تقنية مستقبلية`)
};

const bn_elastic_gallery_item_05_alt = /** @type {(inputs: Elastic_Gallery_Item_05_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভবিষ্যত-নির্ভর টেকনোলজির বিবরণ`)
};

const de_elastic_gallery_item_05_alt = /** @type {(inputs: Elastic_Gallery_Item_05_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Futuristisches Technologiedetail`)
};

const es_elastic_gallery_item_05_alt = /** @type {(inputs: Elastic_Gallery_Item_05_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalle de tecnología futurista`)
};

const fr_elastic_gallery_item_05_alt = /** @type {(inputs: Elastic_Gallery_Item_05_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détail technologique futuriste`)
};

const pt_elastic_gallery_item_05_alt = /** @type {(inputs: Elastic_Gallery_Item_05_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhe de tecnologia futurista`)
};

const zh_elastic_gallery_item_05_alt = /** @type {(inputs: Elastic_Gallery_Item_05_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未来技术细节`)
};

const tr_elastic_gallery_item_05_alt = /** @type {(inputs: Elastic_Gallery_Item_05_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fütüristik teknoloji detayı`)
};

const ru_elastic_gallery_item_05_alt = /** @type {(inputs: Elastic_Gallery_Item_05_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Детали футуристических технологий`)
};

const pl_elastic_gallery_item_05_alt = /** @type {(inputs: Elastic_Gallery_Item_05_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Futurystyczny szczegół technologii`)
};

/**
* | output |
* | --- |
* | "Futuristic technology detail" |
*
* @param {Elastic_Gallery_Item_05_AltInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_05_alt = /** @type {((inputs?: Elastic_Gallery_Item_05_AltInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_05_AltInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_05_alt(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_05_alt(inputs)
	if (locale === "de") return de_elastic_gallery_item_05_alt(inputs)
	if (locale === "es") return es_elastic_gallery_item_05_alt(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_05_alt(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_05_alt(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_05_alt(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_05_alt(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_05_alt(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_05_alt(inputs)
	return en_elastic_gallery_item_05_alt(inputs)
});